import { render, staticRenderFns } from "./project_view.vue?vue&type=template&id=e6d0e8a2&scoped=true&"
import script from "./project_view.vue?vue&type=script&lang=ts&"
export * from "./project_view.vue?vue&type=script&lang=ts&"
import style0 from "./project_view.vue?vue&type=style&index=0&id=e6d0e8a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d0e8a2",
  null
  
)

export default component.exports